import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { PipesModule } from '@mmx/pipes'
import { TranslateModule } from '@ngx-translate/core'
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators'
import { NgxStripeModule } from 'ngx-stripe'

import { PaymentCardFormComponent } from './payment-card-form/payment-card-form.component'
import { StripeFormComponent } from './stripe-form/stripe-form.component'
import { TilledFormComponent } from './tilled-form/tilled-form.component'

@NgModule({
  declarations: [
    PaymentCardFormComponent,
    StripeFormComponent,
    TilledFormComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatFormFieldModule,
    // MatInputModule is required by TilledFormComponent's <input matInput> usage —
    // without it, the matInput directive never registers as a MatFormFieldControl
    // and the surrounding mat-form-field throws on ngAfterContentInit.
    MatInputModule,
    NgxStripeModule,
    TranslateModule,
    PipesModule,
    RxReactiveFormsModule,
  ],
  exports: [PaymentCardFormComponent],
})
export class PaymentCardFormModule {}
